export const createPharmacyFields = [
    {
        name: "pharmacy_name",
        label: "Pharmacy Name",
        type: "text",
        required: true,
            placeholder: "Eg. Sharma medicals",

        colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg: 1
        },
    },
    {
        name: "Owner_name",
        label: "Owner Name",
        type: "text",
            placeholder: "Eg. Rakesh sharma",

        required: true,
        colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg: 1
        },
    },
    {
        name: "mobile",
        label: "Mobile Number",
            placeholder: "Eg. 7478587458",

        type: "mobile",
        required: true,
        colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg: 1
        },
    },
    {
        name: "email",
        label: "Email",
        type: "email",
            placeholder: "Eg. sharma@gmail.com",

        colSpan: {
            base: 6,
            sm: 6,
            md: 3,
            lg: 1
        },
    },
    {
        name: "address",
        label: "Address",
        type: "textarea",
        colSpan: 6,
    },
    {
        name: "status",
        label: "Status",
        type: "select",
        colSpan: {
            base: 6,
            sm: 4,
            md: 2,
            lg:1
        },
        options: [
            { value: "active", label: "Active" },
            { value: "inActive", label: "InActive" },
        ],
    },

];


